import React from 'react'

import Layout from '../components/layout'
import HomeOne from '../components/home/HomeOne'
import HomeAIValueLoop from '../components/home/HomeAIValueLoop'
import HomeTwo from '../components/home/HomeTwo'
import HomeThree from '../components/home/HomeThree'
import HomeFour from '../components/home/HomeFour'

class Home extends React.Component {
  render() {
    return (
      <Layout
        lang="en"
        title="Impactful Tech Solutions"
        meta={{ description: 'Your agile software development team.' }}
        heroBleedBackground
        rootProps={{ className: 'page home' }}
      >
        <HomeOne lang='en' />
        <HomeAIValueLoop lang='en' />
        <HomeTwo lang='en' />
        <HomeThree lang='en' />
        <HomeFour lang='en' />
      </Layout>
    )
  }
}

export default Home
